// extracted by mini-css-extract-plugin
export default {"wrapper":"Press_wrapper__c+Ucs","title":"Press_title__1a86b","infoWrapper":"Press_infoWrapper__z4yDO","info":"Press_info__NUZky"};